module.exports = __webpack_public_path__ + "img/home.ba42285d.png";